var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.booleanSelect)?_c('v-text-field',{attrs:{"label":_vm.label,"readonly":!!_vm.readonly,"error":_vm.isError,"color":"blue"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}):_vm._e(),_vm._v(" "),(_vm.booleanSelect)?_c('v-select',{attrs:{"label":_vm.label,"readonly":!!_vm.readonly,"items":[
      { text: true, value: 1 },
      { text: false, value: 0 }
    ],"color":"blue"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a65158","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/onboarding/UserInfo.vue
// module id = null
// module chunks = 